import { ICrudGenericFields } from 'models/CrudInterface'

export const principalConfigFields: Array<ICrudGenericFields> = [
	{
		id: 'dato',
		type: 'combo',
		labelWidth: 'col-sm-3',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'priceTypeData',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'operacion',
		type: 'combo',
		labelWidth: 'col-sm-3',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'priceOperation',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'pc',
		type: 'text',
		labelWidth: 'col-sm-10',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'redondeo',
		type: 'combo',
		labelWidth: 'col-sm-3',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'priceRound',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'cant_dec',
		type: 'text',
		labelWidth: 'col-sm-6',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 2,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'forma_red',
		type: 'combo',
		labelWidth: 'col-sm-10',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'priceRoundWay',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'respecto',
		type: 'combo',
		labelWidth: 'col-sm-3',
		width: 'col-sm-12',
		height: 'col-sm-4',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'priceRespect',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	}
]
